import { create } from "zustand";
import { set as _set } from "lodash/fp";

export const useTestEngineStore = create((set) => ({
  testPlans: {},
  setTestPlan: (testPlan) => set(_set(["testPlans", testPlan.id], testPlan)),
}));
